// Virtual Try-On GraphQL Mutations

export const virtualTryOn = /* GraphQL */ `
  mutation VirtualTryOn($input: VirtualTryOnInput!) {
    virtualTryOn(input: $input) {
      success
      generatedImageUrl
      s3Key
      cached
      creditsCharged
      processingTime
      metadata
      error
    }
  }
`;

export const regenerateVirtualTryOn = /* GraphQL */ `
  mutation RegenerateVirtualTryOn($input: RegenerateVirtualTryOnInput!) {
    regenerateVirtualTryOn(input: $input) {
      success
      generatedImageUrl
      s3Key
      cached
      creditsCharged
      processingTime
      metadata
      error
    }
  }
`;
